import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme.js';
import { connect } from 'react-redux';

import { request, guid, mapStateToProps, mapDispatchToProps } from '../../utils';
import { submitContactForm } from '../../actions/content';

import TextField from '../../components/TextField';
import Body from '../../components/Body';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ArticleSummary from '../../components/ArticleSummary';
import SearchField from '../../components/SearchField';
import ContentContainer from '../../components/ContentContainer';
import Button from '../../components/Button';
import SelectField from '../../components/SelectField';

const EMAIL_ICON = require('./email.png');

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: props.match.id,
      full_name: '',
      email: '',
      enquiry_type: '',
      phone: '',
      message: '',
      submitted: false,
    };

    this.setValue = this.updateField.bind(this);
  }

  updateField(key, value) {
    this.setState({
      [key]: value,
    });
  }

  submitForm() {
    this.props.dispatch(
      submitContactForm(this.state)
    ).then((response) => {
      console.log(response);
    });

    this.setState({
      submitted: true,
    });
  }

  render() {
    return (
      <Body
        title="Contact - Sniffers"
        player={this.props.player}
        history={this.props.history}
        search={this.props.search}
        dispatch={this.props.dispatch}>
        <Header content={this.props.content} dispatch={this.props.dispatch} />
        <ContentContainer>
          <div className={css(styles.content_container)}>
            <div className={css(styles.page_title)}>
              Contact.
            </div>
            <div className={css(styles.column_container)}>
              <div className={css(styles.left_column)}>
                <p className={css(styles.paragraph)}>We're always keen to hear from like-minded people. Get in touch below, or fill out the form to the right. Keep sniffin'</p>
                <p className={css(styles.paragraph)}><img src={EMAIL_ICON} className={css(styles.email)} /> submissions@sniffers.co.nz</p>
                <p className={css(styles.paragraph)}><img src={EMAIL_ICON} className={css(styles.email)} /> marketing@sniffers.co.nz</p>
              </div>
              <div className={css(styles.right_column)}>
                <div className={css(styles.form_group)}>
                  <TextField placeholder="Full name *" handler={this.setValue} name="full_name" value={this.state.full_name} />
                  <TextField placeholder="Email address *" handler={this.setValue} name="email" value={this.state.email} />
                </div>
                <div className={css(styles.form_group)}>
                  <SelectField
                    id="enquiry_type"
                    name="enquiry_type"
                    options={[
                      {
                        value: 'Artist Submissions',
                        label: 'Artist Submissions',
                      },
                      {
                        value: 'Marketing',
                        label: 'Marketing',
                      },
                      {
                        value: 'Events',
                        label: 'Events',
                      },
                      {
                        value: 'Press & Media',
                        label: 'Press & Media',
                      },
                      {
                        value: 'Other',
                        label: 'Other',
                      },
                    ]}
                    value={this.state.enquiry_type}
                    handler={this.setValue}
                    label="Enquiry type *"
                    required
                  />
                  <TextField placeholder="Phone number" handler={this.setValue} name="phone" value={this.state.phone} />
                </div>
                <div className={css(styles.form_group)}>
                  <TextField placeholder="Message *" fullWidth handler={this.setValue} name="message" textArea value={this.state.message} />
                </div>
                <div className={css(styles.button_container)}>
                  {
                    this.state.submitted ? (
                      <p className={css(styles.paragraph)}>
                        Thanks for getting in touch. We{'\''}ll get back to you as soon as we can.
                      </p>
                    ) : (
                      <Button title="Send now" handler={this.submitForm.bind(this)} />
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        </ContentContainer>
        <Footer />
      </Body>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Contact);

const styles = StyleSheet.create({
  content_container: {
    display: 'flex',
    width: Theme.container_width - (Theme.margin_width * 2),
    margin: '40px auto 0px',
    paddingTop: 20,
    paddingBottom: 100,
    flexDirection: 'column',
    [Theme.mobile_query]: {
      width: '90%',
    },
  },
  email: {
    width: 32,
    height: 32,
    marginRight: 30,
  },
  column_container: {
    display: 'flex',
    flexDirection: 'row',
    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  page_title: {
    fontFamily: Theme.fontFamily,
    fontWeight: '900',
    fontSize: 48,
    marginTop: 40,
    marginBottom: 40,
  },
  paragraph: {
    marginBottom: 30,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    lineHeight: '24px',
  },
  left_column: {
    width: 450,
    [Theme.mobile_query]: {
      width: '100%',
      boxSizing: 'border-box',
      padding: 10,
    },
  },
  right_column: {
    width: 700,
    paddingLeft: 20,
    [Theme.mobile_query]: {
      width: '100%',
      boxSizing: 'border-box',
      padding: 10,
    },
  },
  form_group: {
    display: 'flex',
    flexDirection: 'row',
    margin: '0px 0px 20px',

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  button_container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
});



// WEBPACK FOOTER //
// ./src/views/Contact/index.js